import React from "react";

export default function WhyChooseUs() {
  const reasons = [
    {
      title: "Real-Time Tracking",
      desc: "Track every shipment with live status updates.",
      icon: "bi-speedometer2"
    },
    {
      title: "Affordable Pricing",
      desc: "Competitive rates with no hidden charges.",
      icon: "bi-currency-dollar"
    },
    {
      title: "Fast & Secure Delivery",
      desc: "Guaranteed safe & on-time package delivery.",
      icon: "bi-lightning-charge"
    },
    {
      title: "24/7 Professional Support",
      desc: "Our logistics experts are always available.",
      icon: "bi-headset"
    },
    {
      title: "Trusted by 10,000+ Customers",
      desc: "Years of experience in global logistics.",
      icon: "bi-people-fill"
    }
  ];

  return (
    <>
      {/* ⭐ INLINE PREMIUM CSS */}
      <style>{`
        .choose-section {
          padding: 80px 0;
          background: linear-gradient(135deg, #f2f7ff, #ffffff);
        }

        .choose-title {
          font-size: 34px;
          font-weight: 800;
          margin-bottom: 15px;
        }

        .choose-title::after {
          content: "";
          width: 90px;
          height: 4px;
          border-radius: 6px;
          background: linear-gradient(90deg, #005eff, #f80b0b);
          display: block;
          margin: 10px auto 0;
        }

        .reason-card {
          background: white;
          padding: 35px 25px;
          border-radius: 18px;
          text-align: center;
          border: 1px solid rgba(0,0,0,0.06);
          box-shadow: 0px 8px 20px rgba(0,0,0,0.08);
          transition: 0.35s ease;
          opacity: 0;
          animation: fadeUp 0.9s forwards;
        }

        .reason-card:hover {
          transform: translateY(-10px);
          box-shadow: 0px 15px 30px rgba(0,94,255,0.25);
          border-color: #005eff;
        }

        .reason-icon {
          font-size: 45px;
          color: #005eff;
          margin-bottom: 15px;
          transition: 0.3s ease;
        }

        .reason-card:hover .reason-icon {
          transform: scale(1.2);
          color: #f80b0b;
        }

        .reason-title {
          font-weight: 700;
          font-size: 20px;
          margin-bottom: 10px;
        }

        .reason-desc {
          font-size: 15px;
          color: #555;
        }

        /* Animation */
        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(25px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* ⭐ SECTION START */}
      <section className="choose-section">
        <div className="container">

          <h2 className="text-center choose-title fadeUp" style={{ animationDelay: "0.1s" }}>
            Why Choose SWIFTSHIP?
          </h2>

          <p className="text-center text-muted mb-5 fadeUp" style={{ animationDelay: "0.2s" }}>
            Experience world-class logistics backed by technology, expertise, and trust.
          </p>

          <div className="row g-4">
            {reasons.map((r, i) => (
              <div className="col-md-4" key={i}>
                <div className="reason-card" style={{ animationDelay: `${0.3 + i * 0.15}s` }}>
                  
                  <i className={`bi ${r.icon} reason-icon`}></i>

                  <h4 className="reason-title">{r.title}</h4>

                  <p className="reason-desc">{r.desc}</p>

                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
    </>
  );
}
